<h2 mat-dialog-title class="bgDialogHeader text-center">SubCustomer Details
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <nb-card>
    <div class="col-md-12">
      <div class="col-md-12 p-1">
        <div class="data-table-event-file mt-4">
          <table id="accordion" class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">SubCustomer Name</th>
                <th scope="col">Edit Profile</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  </nb-card>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="onNoClick()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right"> Close </button>
</mat-dialog-actions>
